import * as React from 'react';
import * as ReactDOM from 'react-dom';
import ConversationWrapper from './components/clearstep/Conversation/ConversationWrapper';
var props = window.convoProps;
var domContainer = document.getElementById('conversation');
if (domContainer) {
    ReactDOM.render(React.createElement(ConversationWrapper, props), domContainer);
}
else {
    console.error('ConversationEntry failed to load');
}
